<div class="container mt-4 mb-5">
  <div class="row">
    <div class="col-lg-2 mb-3 pr-3" style="padding-left: 0 !important">
      <h4 i18n>Cadastros</h4>
      <div class="gcc-menudrop dropdown-menu">
        <div *ngFor="
            let cadastro of initProvider.usuario.nivel[0].elementos;
            let i = index
          ">
          <a class="dropdown-item anchor-select" (click)="setPage(cadastro.ordem)" *ngIf="cadastro.listar">
            {{ cadastro.rota.replaceAll("_", " ") }}
          </a>
        </div>
        <!-- <a
          *ngIf="initProvider.usuario.nivel.cadastro[0].listar"
          (click)="setPage(1)"
          class="dropdown-item anchor-select"
          >Representante</a
        >
        <a
          *ngIf="initProvider.usuario.nivel.cadastro[1].listar"
          (click)="setPage(2)"
          class="dropdown-item anchor-select"
          >Cliente</a
        > -->
      </div>
    </div>
    <div *ngIf="list === 2" class="col-10" style="border-left: 1px solid #e5e5e5">
      <div class="row justify-content-between">
        <div class="col-11">
          <h5 i18n>Representantes</h5>
        </div>
        <div class="col" *ngIf="!filter">
          <button style="background-color: transparent; border: none" (click)="setPage(2)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <form [formGroup]="form" autocomplete="off">
        <div class="row" *ngIf="filter">
          <div class="form-group col-3">
            <label i18n>Nome</label>
            <input name="nome" formControlName="nome" type="text" maxlength="60" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label i18n>Documento</label>
            <input name="documento" formControlName="documento" type="text" maxlength="255" class="form-control" />
          </div>
          <div class="col-2">
            <label i18n>Status</label>
            <select class="form-control" id="status" name="status" formControlName="status">
              <option value="">Todos</option>
              <option value="PENDENTE">Pendente</option>
              <option value="RECUSADO">Recusado</option>
            </select>
          </div>
          <div class="col-1 align-self-center">
            <button *ngIf="initProvider.usuario.nivel[0].elementos[list - 1]" (click)="getRepresentantes(true)"
              class="btn btn-primary">
              Filtrar
            </button>
          </div>
          <div class="col-2 align-self-center">
            <button *ngIf="initProvider.usuario.nivel[0].elementos[list - 1].incluir" class="btn btn-secondary"
              [style.backgroundColor]="'black'" (click)="abrirCadastro()">
              Cadastrar
            </button>
          </div>
        </div>
      </form>
      <div class="row" style="padding-left: 15px" *ngIf="representantes.length > 0 && filter">
        <table class="table table-hover table-condensed table-responsive-md">
          <thead>
            <tr>
              <th scope="col" i18n>Nome</th>
              <th scope="col" i18n>Documento</th>
              <th scope="col" i18n>Aprovado</th>
              <th scope="col" i18n>Alerta</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of representantes">
              <td>{{ b.nome }}</td>
              <td>{{ b.numdocumento }}</td>
              <td>{{ b.status }}</td>
              <td *ngIf="b.erro_integracao === null"></td>
              <td *ngIf="b.erro_integracao !== null" class="text-center align-middle">
                <button style="border: none" class="btn btn-outline-primary" [title]="b.erro_integracao">
                  <mat-icon>warning</mat-icon>
                </button>
              </td>
              <td class="text-center align-middle">
                <div class="d-flex flex-row" [style.maxWidth]="'142px'">
                  <button *ngIf="
                      initProvider.usuario.nivel[0].elementos[list - 1].alterar
                    " data-toggle="modal" data-target="#boletoModal" title="Editar" style="border-radius: 4px"
                    class="btn btn-outline-primary col" (click)="editarCadastro(b.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button *ngIf="
                      initProvider.usuario.nivel[0].elementos[list - 1].aprovar
                    " data-toggle="modal" data-target="#confirmAprovaModal" title="Aprovar" style="border-radius: 4px"
                    class="btn btn-outline-primary ml-2 col" (click)="selectaprovar(b.id, b.nome)">
                    <mat-icon>approval</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="pageable && representantes.length > 0" class="row" style="width: 100%">
          <div class="col-lg-4 pl-0">
            <label i18n>Página {{ pageNumber }} de {{ totalPages }}</label>
          </div>
          <div class="col-lg-4">
            <pagination [totalItems]="totalElements" [maxSize]="5" [itemsPerPage]="20" [disabled]="false"
              [(ngModel)]="pageNumber" (pageChanged)="pageChangedReps($event)" previousText="&lsaquo;"
              nextText="&rsaquo;">
            </pagination>
          </div>
          <div class="col-lg-4 text-right pr-0">
            <label i18n>{{ representantes.length }} registros encontrados</label>
          </div>
        </div>
      </div>
      <div class="col" *ngIf="!filter">
        <div class="row" style="padding-left: 15px">
          <h5 i18n>Cadastro de representante</h5>
        </div>
        <novo-representante [selectedClient]="selectedRepresentante" [cadastroCliente]="false" [edit]="edit"
          (page)="setPage($event)"></novo-representante>
      </div>
    </div>
    <div *ngIf="list === 1" class="col-10" style="border-left: 1px solid #e5e5e5">
      <div class="row justify-content-between">
        <div class="col-11">
          <h5 i18n>Clientes</h5>
        </div>
        <div class="col" *ngIf="!filter">
          <button style="background-color: transparent; border: none" (click)="setPage(1)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      <form [formGroup]="form" autocomplete="off">
        <div class="row" *ngIf="filter">
          <div class="form-group col-3">
            <label i18n>Nome</label>
            <input name="nome" formControlName="nome" type="text" maxlength="255" class="form-control" />
          </div>
          <div class="form-group col-3">
            <label i18n>Documento</label>
            <input name="documento" formControlName="documento" type="text" maxlength="255" class="form-control" />
          </div>
          <div class="col-2">
            <label>Status</label>
            <select class="form-control" id="status" name="status" formControlName="status"
              (change)="change($event.target.value)">
              <option i18n value="">Todos</option>
              <option i18n value="PENDENTE">Pendente</option>
              <option i18n value="RECUSADO">Recusado</option>
            </select>
          </div>
          <div class="col-1 align-self-center">
            <button *ngIf="initProvider.usuario.nivel[0].elementos[list - 1].listar" (click)="getClientes(true)"
              class="btn btn-primary" i18n>
              Filtrar
            </button>
          </div>
          <div class="col-2 align-self-center" *ngIf="initProvider.usuario.nivel[0].elementos[list - 1].incluir">
            <button *ngIf="initProvider.usuario.nivel[0].elementos[list - 1].incluir" class="btn btn-secondary"
              [style.backgroundColor]="'black'" (click)="abrirCadastro()" i18n>
              Cadastrar
            </button>
          </div>
        </div>
      </form>
      <div class="row" style="padding-left: 15px" *ngIf="filter">
        <table class="table table-hover table-condensed table-responsive-md">
          <thead>
            <tr>
              <th scope="col" i18n>Código</th>
              <th scope="col" i18n>Nome</th>
              <th scope="col" i18n>Documento</th>
              <th scope="col" i18n>Aprovado</th>
              <th scope="col" i18n class="col-limite">R$ Limite</th>
              <th scope="col" i18n class="col-risco">Risco</th>
              <th scope="col" i18n class="col-alerta">Alerta</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let b of clientes">
              <td>{{ b.codigo }}</td>
              <td>{{ b.nome }}</td>
              <td>{{ b.numdocumento }}</td>
              <td>{{ b.status }}</td>
              <td class="col-limite">
                <span *ngIf="b.limite_credito !== null">R${{ b.limite_credito | currency : "BRL" : "" }}</span>
              </td>
              <td class="col-risco">{{ b.risco }}</td>
              <td class="col-alerta" *ngIf="b.erro_integracao === null"></td>
              <td *ngIf="b.erro_integracao !== null" class="text-center align-middle">
                <button style="border: none" class="btn btn-outline-primary" [title]="b.erro_integracao">
                  <mat-icon>warning</mat-icon>
                </button>
              </td>
              <td class="text-center align-middle d-flex flex-row">
                <button data-toggle="modal" data-target="#detalhesClienteModal" title="Detalhes"
                  style="border-radius: 4px" class="btn btn-outline-primary col btn-detalhes" (click)="showDetails(b)"
                  *ngIf="
                  initProvider.usuario.nivel[0].elementos[list - 1].alterar
                ">
                  <mat-icon>attach_money</mat-icon>
                </button>
                <button data-toggle="modal" data-target="#boletoModal" title="Editar" style="border-radius: 4px"
                  class="btn btn-outline-primary col ml-2" (click)="editarCadastroCliente(b.id)" *ngIf="
                    initProvider.usuario.nivel[0].elementos[list - 1].alterar
                  ">
                  <mat-icon>edit</mat-icon>
                </button>
                <button data-toggle="modal" data-target="#confirmAprovaClienteModal" title="Aprovar"
                  class="btn btn-outline-primary col ml-2" style="border-radius: 4px" (click)="
                    selectaprovar(b.id, b.nome, b.revisar_cadastro, b.risco, b.limite_credito)
                  " *ngIf="
                    initProvider.usuario.nivel[0].elementos[list - 1].aprovar
                  ">
                  <mat-icon>approval</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="pageable" class="row" style="width: 100%">
          <div class="col-lg-4 pl-0">
            <label i18n>Página {{ pageNumber }} de {{ totalPages }}</label>
          </div>
          <div class="col-lg-4">
            <pagination [totalItems]="totalElements" [itemsPerPage]="20" [disabled]="false" [(ngModel)]="pageNumber"
              (pageChanged)="pageChangedClients($event)" previousText="&lsaquo;" nextText="&rsaquo;" [maxSize]="5">
            </pagination>
          </div>
          <div class="col-lg-4 text-right pr-0">
            <label i18n>{{ clientes.length }} registros encontrados</label>
          </div>
        </div>
      </div>

      <div class="col" *ngIf="!filter">
        <div class="row" style="padding-left: 15px">
          <h5 i18n>Cadastro de clientes</h5>
        </div>
        <novo-cliente [selectedClient]="selectedCliente" [cadastros]="true" [cadastroCliente]="false" [edit]="edit"
          (page)="setPage($event)"></novo-cliente>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="confirmAprovaModal" tabindex="-1" role="dialog" aria-labelledby="confirmAprovaModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Deseja realmente aprovar?<br />
          <span>{{ this.nome }}</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-footer">
        <button type="button" data-dismiss="modal" class="btn btn-outline-primary" (click)="aprovar()" i18n>
          Aprovar
        </button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="reprovar()" i18n>
          Reprovar
        </button>
        <button type="button" data-dismiss="modal" class="btn" style="background: black; color: white" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="confirmAprovaClienteModal" tabindex="-1" role="dialog"
  aria-labelledby="confirmAprovaClienteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Deseja realmente aprovar?<br />
          <span>{{ this.nome }}</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-3">
          <form [formGroup]="formCliente" autocomplete="off" style="width: 100%">
            <div class="col-12 row">
              <div *ngIf="aprovaCliente.limiteCredito.visible" class="mb-4 col-5 limite-col">
                <label i18n [ngClass]="{ 'text-danger': error && formCliente.get('limiteCredito').invalid }">
                  Limite de crédito
                </label>
                <input name="limiteCredito" formControlName="limiteCredito" class="form-control" i18n
                  placeholder="Limite de crédito" appCurrency
                  [ngClass]="{ 'is-invalid text-danger': error && formCliente.get('limiteCredito').invalid }" />
                <div *ngIf="error && formCliente.get('limiteCredito').invalid" class="error text-danger" i18n>
                  Verifique este campo!
                </div>
              </div>

              <div *ngIf="aprovaCliente.risco.visible" class="mb-4 col-4 risco-col">
                <label i18n [ngClass]="{ 'text-danger': error && formCliente.get('risco').invalid }">
                  Risco
                </label>
                <select class="form-control" name="risco" formControlName="risco"
                  [ngClass]="{ 'is-invalid text-danger': error && formCliente.get('risco').invalid }">
                  <option value=""></option>
                  <option *ngFor="let r of riskList" [value]="r">
                    {{ r }}
                  </option>
                </select>
                <div *ngIf="error && formCliente.get('risco').invalid" class="error text-danger" i18n>
                  Verifique este campo!
                </div>
              </div>

              <div class="col-3 cria-usuario-col">
                <label>Criar usuário</label>
                <label class="switch" for="checkbox">
                  <input type="checkbox" id="checkbox" name="criaUsuario" formControlName="criaUsuario" />
                  <div class="slider round"></div>
                </label>
                <!-- <input
                  type="checkbox"
                  class="form-control"
                  name="criaUsuario"
                  formControlName="criaUsuario"
                  style="height: 25px"
                /> -->
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="aprovarCliente()" i18n>
          Aprovar
        </button>
        <button type="button" class="btn btn-primary" (click)="reprovarCliente()" i18n>
          Reprovar
        </button>
        <button type="button" data-dismiss="modal" class="btn" style="background: black; color: white" i18n>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="detalhesClienteModal" tabindex="-1" role="dialog"
  aria-labelledby="detalhesClienteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" i18n>
          Detalhes do cliente<br />
          <span>{{ this.userDetails.numdocumento }} - {{ this.userDetails.nome }}</span>
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row mt-3">
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Código</label><br>
              <label>
                <b>
                  {{ this.userDetails.codigo }}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Nome</label><br>
              <label>
                <b>
                  {{ this.userDetails.nome }}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>{{ this.userDetails.tipodocumento }}</label><br>
              <label>
                <b>
                  {{ this.userDetails.numdocumento }}
                </b>
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Fantasia</label><br>
              <label>
                <b>
                  {{ this.userDetails.fantasia}}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Cidade</label><br>
              <label>
                <b>
                  {{ this.userDetails.cidades.nome}} - {{ this.userDetails.cidades.uf }}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Adimplente</label><br>
              <label>
                <div>
                  <i *ngIf="this.userDetails.bloqueiaPedidos else elseBlockOrder" class="icofont-close"
                    style="color: red; font-size: 25px"></i>
                  <ng-template #elseBlockOrder>
                    <i class="icofont-check" style="color: green; font-size: 28px"></i>
                  </ng-template>
                </div>
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Email</label><br>
              <label>
                <b>
                  {{ this.userDetails.email }}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Limite Disponível</label><br>
              <label>
                <b>
                  R$ {{this.userDetails.limite_disponivel | currency : "BRL" : "" }}
                </b>
              </label>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Limite de crédito</label><br>
              <label>
                <b>
                  R$ {{this.userDetails.limite_credito | currency : "BRL" : "" }}
                </b>
              </label>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-lg-4">
            <div class="form-group mb-1">
              <label>Telefone</label><br>
              <label>
                <b>
                  ({{ this.userDetails.ddd }}) {{ this.userDetails.telefone }}
                </b>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal" class="btn" style="background: black; color: white" i18n>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>